import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const NextTrackIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M15.5192 11.1362L6.50387 5.87726C5.83721 5.48838 5 5.96925 5 6.74104V17.259C5 18.0308 5.83721 18.5116 6.50387 18.1227L15.5192 12.8638C16.1807 12.4779 16.1807 11.5221 15.5192 11.1362Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { NextTrackIcon };
